// Need to use the React-specific entry point to import createApi
import type {
  GetListResponseOfRiskAssessmentCodeResponse,
  GetTaskListRequestV2,
  RiskAssessmentCodeAreaEnum,
  RiskAssessmentCodeRequest,
  RiskAssessmentCodeResponse,
} from 'src/api/ProactApiClient';
import {riskAssessmentCodeApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const riskAssessmentCodeApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getRiskAssessmentCodeListV2: builder.query<
      GetListResponseOfRiskAssessmentCodeResponse,
      GetTaskListRequestV2
    >({
      queryFn: clientQuery(request =>
        riskAssessmentCodeApiClient.listV2(request)
      ),
      providesTags: ['RiskAssessmentCodes'],
    }),
    getRiskAssessmentCode: builder.query<RiskAssessmentCodeResponse, number>({
      queryFn: clientQuery(id => riskAssessmentCodeApiClient.get(id)),
      providesTags: ['RiskAssessmentCodes'],
    }),
    getRiskAssessmentCodeByArea: builder.query<
      RiskAssessmentCodeResponse,
      RiskAssessmentCodeAreaEnum
    >({
      queryFn: clientQuery(area => riskAssessmentCodeApiClient.getByArea(area)),
      providesTags: ['RiskAssessmentCodes'],
    }),
    createRiskAssessmentCode: builder.mutation<
      RiskAssessmentCodeResponse,
      RiskAssessmentCodeRequest
    >({
      queryFn: clientQuery(request =>
        riskAssessmentCodeApiClient.create(request)
      ),
      invalidatesTags: ['RiskAssessmentCodes'],
    }),
    updateRiskAssessmentCode: builder.mutation<
      RiskAssessmentCodeResponse,
      RiskAssessmentCodeRequest
    >({
      queryFn: clientQuery(request =>
        riskAssessmentCodeApiClient.update(request)
      ),
      invalidatesTags: ['RiskAssessmentCodes'],
    }),
    deleteRiskAssessmentCode: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => riskAssessmentCodeApiClient.delete(id)),
      invalidatesTags: ['RiskAssessmentCodes'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRiskAssessmentCodeQuery,
  useGetRiskAssessmentCodeByAreaQuery,
  useGetRiskAssessmentCodeListV2Query,
  useCreateRiskAssessmentCodeMutation,
  useUpdateRiskAssessmentCodeMutation,
  useDeleteRiskAssessmentCodeMutation,
} = riskAssessmentCodeApi;
